<!-- Page 1 -->
<div class="pdf-page app-aul-013-24" id="aul01324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>FLORIDA CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b
      >This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE</u></b>
  </p>
  <p class="font-medium" style="text-align: justify; width: 95%;">
    <b
      >THIS INSURANCE IS ISSUED PURSUANT TO THE FLORIDA SURPLUS LINES LAW.
      PERSONS INSURED BY SURPLUS LINES CARRIERS DO NOT HAVE THE PROTECTION OF
      THE FLORIDA INSURANCE GUARANTY ACT TO THE EXTENT OF ANY RIGHT OF RECOVERY
      FOR THE OBLIGATION OF AN INSOLVENT UNLICENSED INSURER.</b
    >
  </p>
  <br /><br />
  <p class="font-medium" style="text-decoration: underline; text-align: center">
    <b>RATE AND FORM APPROVAL DISCLOSURE</b>
  </p>
  <p class="font-medium" style="text-align: center">
    <b
      >SURPLUS LINES INSURERS' POLICY RATES AND FORMS ARE NOT APPROVED BY ANY
      FLORIDA REGULATORY AGENCY</b
    >
  </p>
  <br /><br />
</div>

<!-- Page 2 -->
<div class="pdf-page app-aul-013-24-01">
  <div class="t-right p-5">
    <p class="font-small mb-0"><b>COMMERCIAL PROPERTY</b></p>
    <p class="font-small"><b>CP 01 25 02 12</b></p>
  </div>

  <p class="font-medium" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY.</b>
  </p>

  <p class="font-large" style="text-align: center">
    <b>FLORIDA CHANGES</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>

  <p style="text-align: left">COMMERCIAL PROPERTY COVERAGE PART</p>
  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">          
          <ol type="A" style="text-align: justify;">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              When this endorsement is attached to Standard Property Policy
              <b>CP 00 99,</b> the term Coverage Part in this endorsement is
              replaced by the term Policy.
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following provision applies when a Coinsurance percentage is
              shown in the Declarations:<br />
              Florida law states as follows:<br />
              Coinsurance contract: The rate charged in this policy is based
              upon the use of the coinsurance clause attached to this policy,
              with the consent of the Insured.
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following is added:<br />
              If windstorm is a Covered Cause of Loss and loss or damage to
              Covered Property is caused by or results from windstorm, the
              following exclusion applies in:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Broward County;</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Dade County;</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Martin County;</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Monroe County;</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Palm Beach County; and</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  All the areas east of the west bank of the Intracoastal
                  Waterway in the counties of:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Indian River; and</span>
                </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">St. Lucie.</span>
                </li>
                  </ol>
                </span>
                </li>
              </ol>
              <b>Windstorm Exterior Paint And Waterproofing Exclusion</b><br />
              We will not pay for loss or damage caused by windstorm to:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Paint; or</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Waterproofing material;</span>
                </li>
              </ol>
              applied to the exterior of buildings unless the building to which
              such loss or damage occurs also sustains other loss or damage by
              windstorm in the course of the same storm event. But such coverage
              applies only if windstorm is a Covered Cause of Loss.
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none; text-align: justify;">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              When loss or damage to exterior paint or waterproofing material is
              excluded, we will not include the value of paint or waterproofing
              material to determine:
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">The amount of the Windstorm or Hail Deductible; or</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The value of Covered Property when applying the Coinsurance
                  Condition.
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ul>
          <ol type="A" start="4" style="text-align: justify;">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The <b>Loss Payment</b> Condition dealing with the number of days
              within which we must pay for covered loss or damage is replaced by
              the following: <br />
              Provided you have complied with all the terms of this Coverage
              Part, we will pay for covered loss or damage upon the earliest of
              the following:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1) </b>Within 20 days after we receive the sworn proof of
                  loss and reach written agreement with you;
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>Within 30 days after we receive the sworn proof of
                  loss and:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(a) </b>There is an entry of a final judgment; or
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) </b>There is a filing of an appraisal award with
                      us; or
                    </span>
                    </li>
                  </ul>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(3) </b>Within 90 days of receiving notice of an initial,
                  reopened or supplemental claim, unless we deny the claim
                  during that time or factors beyond our control reasonably
                  prevent such payment. If a portion of the claim is denied,
                  then the 90-day time period for payment of claim relates to
                  the portion of the claim that is not denied. Paragraph (3)
                  applies only to the following:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(a) </b>A claim under a policy covering residential
                      property;
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) </b>A claim for building or contents coverage if
                      the insured structure is 10,000 square feet or less and
                      the policy covers only locations in Florida: or
                    </span>
                    </li>
                  </ul>
                </span>
                </li>
              </ul>
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 3 -->
<div class="pdf-page app-aul-013-24-01">
  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(c) </b> A claim for contents coverage under a tenant's
                  policy if the rented premises are 10,000 square feet or less
                  and the policy covers only locations in Florida.
                </span>
                </li>
              </ul>
            </span>
            </li>
          </ul>
          <ol type="A" start="5">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Sinkhole Collapse Coverage Removed</b><br />
              Sinkhole Collapse coverage is removed, as indicated in Paragraphs
              <b>E.1.</b> through <b>E.4.;</b> and coverage for Catastrophic
              Ground Cover Collapse is added instead as set forth in Paragraph
              <b>F.</b>
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  In the Causes Of Loss — Basic Form and in the Standard
                  Property Policy, Sinkhole Collapse is deleted from the Covered
                  Causes of Loss and sinkhole collapse is no longer an exception
                  to the Earth Movement Exclusion.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  In the Causes Of Loss — Broad Form, Sinkhole Collapse is
                  deleted from the Covered Causes of Loss and from the
                  Additional Coverage —Collapse; and sinkhole collapse is no
                  longer an exception to the Earth Movement Exclusion.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  In the Causes Of Loss — Special Form, Sinkhole Collapse is
                  deleted from the "specified causes of loss" and is no longer
                  an exception to the Earth Movement Exclusion.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  In the Mortgageholders Errors And Omissions Coverage Form,
                  Sinkhole Collapse is deleted from the Covered Causes of Loss
                  under Coverage <b>B</b> and from the "specified causes of
                  loss", and is no longer an exception to the Earth Movement
                  Exclusion.
                </span>
                </li>
              </ol>
              Further, this Coverage Part does not insure against Sinkhole Loss
              as defined in Florida law unless an endorsement for Sinkhole Loss
              is made part of this policy. However, if Sinkhole Loss causes
              Catastrophic Ground Cover Collapse, coverage is provided for the
              resulting Catastrophic Ground Cover Collapse even if an
              endorsement for Sinkhole Loss is not made part of this policy.
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following is added to this Coverage Part as a Covered Cause of
              Loss. In the Causes Of Loss —Special Form and Mortgageholders
              Errors And Omissions Coverage Form, the following is also added as
              a "specified cause of loss". However, as a "specified cause of
              loss", the following does not apply to the Additional Coverage —
              Collapse.
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Catastrophic Ground Cover Collapse</b><br />
              We will pay for direct physical loss or damage to Covered Property
              caused by or resulting from catastrophic ground cover collapse,
              meaning geological activity that results in all of the following:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">The abrupt collapse of the ground cover;</span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  A depression in the ground cover clearly visible to the naked
                  eye;
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  "Structural damage" to the building, including the foundation;
                  and
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The insured structure being condemned and ordered to be
                  vacated by the governmental agency authorized by law to issue
                  such an order for that structure.
                </span>
                </li>
                However, damage consisting merely of the settling or cracking of
                a foundation, structure or building does not constitute loss or
                damage resulting from a catastrophic ground cover collapse.<br />
                The
                <b>Earth Movement</b>
                Exclusion and the
                <b>Collapse</b>
                Exclusion do not apply to coverage for Catastrophic Ground Cover
                Collapse.<br />
                Coverage for Catastrophic Ground Cover Collapse does not
                increase the applicable Limit of Insurance. Regardless of
                whether loss or damage attributable to catastrophic ground cover
                collapse also qualifies as Sinkhole Loss or Earthquake (if
                either or both of those causes of loss are covered under this
                Coverage Part), only one Limit of Insurance will apply to such
                loss or damage.
              </ol>
            </span>
            </li>
          </ul>
          <ol type="A" start="7">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following applies to the
              <b>Additional Coverage — Civil Authority</b> under the Business
              Income (And Extra Expense) Coverage Form, Business Income (Without
              Extra Expense) Coverage Form and Extra Expense Coverage Form:
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The Additional Coverage — Civil Authority includes a
                  requirement that the described premises are not more than one
                  mile from the damaged property. With respect to described
                  premises located in Florida, such one-mile radius does not
                  apply.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The Additional Coverage — Civil Authority is limited to a
                  coverage period of up to four weeks. With respect to described
                  premises located in Florida, such four-week period is replaced
                  by a three-week period.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Civil Authority coverage is subject to all other provisions of
                  that Additional Coverage.
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 4 -->
<div class="pdf-page app-aul-013-24-01">
  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          <ol type="A" start="8">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following provisions are added to the
              <b>Duties In The Event Of Loss Or Damage</b> Loss Condition:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1) </b>A claim, supplemental claim or reopened claim for
                  loss or damage caused by hurricane or other windstorm is
                  barred unless notice of claim is given to us in accordance
                  with the terms of this policy within three years after the
                  hurricane first made landfall or a windstorm other than
                  hurricane caused the covered damage. (Supplemental claim or
                  reopened claim means an additional claim for recovery from us
                  for losses from the same hurricane or other windstorm which we
                  have previously adjusted pursuant to the initial claim.)<br />
                  This provision concerning time for submission of claim,
                  supplemental claim or reopened claim does not affect any
                  limitation for legal action against us as provided in this
                  policy under the Legal Action Against Us Condition, including
                  any amendment to that condition.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>Any inspection or survey by us, or on our behalf,
                  of property that is the subject of a claim, will be conducted
                  with at least 48 hours' notice to you. The 48-hour notice may
                  be waived by you.
                </span>
                </li>
              </ul>
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following definition of structural damage is added with
              respect to the coverage provided under this endorsement:<br />
              "Structural damage" means a covered building, regardless of the
              date of its construction, has experienced the following.
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Interior floor displacement or deflection in excess of
                  acceptable variances as defined in ACI 117-90 or the Florida
                  Building Code, which results in settlement related damage to
                  the interior such that the interior building structure or
                  members become unfit for service or represent a safety hazard
                  as defined within the Florida Building Code;
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ol start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Foundation displacement or deflection in excess of acceptable
              variances as defined in ACI 318-95 or the Florida Building Code,
              which results in settlement related damage to the primary
              structural members or primary structural systems that prevents
              those members or systems from supporting the loads and forces they
              were designed to support to the extent that stresses in those
              primary structural members or primary structural systems exceed
              one and one-third the nominal strength allowed under the Florida
              Building Code for new buildings of similar structure, purpose, or
              location;
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Damage that results in listing, leaning, or buckling of the
              exterior load bearing walls or other vertical primary structural
              members to such an extent that a plumb line passing through the
              center of gravity does not fall inside the middle one-third of the
              base as defined within the Florida Building Code;
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Damage that results in the building, or any portion of the
              building containing primary structural members or primary
              structural systems, being significantly likely to imminently
              collapse because of the movement or instability of the ground
              within the influence zone of the supporting ground within the
              sheer plane necessary for the purpose of supporting such building
              as defined within the Florida Building Code; or
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Damage occurring on or after October 15, 2005, that qualifies as
              substantial structural damage as defined in the Florida Building
              Code.
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 5 -->
<div class="pdf-page app-aul-013-24-02">
  <div class="t-right p-5">
    <p class="font-small"><b>IL 02 55 03 16</b></p>
  </div>

  <p class="font-medium" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>

  <p class="font-large mb-0" style="text-align: center">
    <b>FLORIDA CHANGES - CANCELLATION</b>
  </p>
  <p class="font-large" style="text-align: center"><b>AND NONRENEWAL</b></p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>

  <ul class="font-small" style="list-style-type: none">
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">CAPITAL ASSETS PROGRAM (OUTPUT POLICY) COVERAGE PART</span>
                </li>
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">COMMERCIAL INLAND MARINE COVERAGE PART</span>
                </li>
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">COMMERCIAL PROPERTY COVERAGE PART</span>
                </li>
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">CRIME AND FIDELITY COVERAGE PART</span>
                </li>
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">EQUIPMENT BREAKDOWN COVERAGE PART</span>
                </li>
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">FARM COVERAGE PART</span>
                </li>
    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">STANDARD PROPERTY POLICY</span>
                </li>
  </ul>

  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          <ol type="A">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Paragraph <b>2.</b> of the <b>Cancellation</b> Common Policy
              Condition is replaced by the following:
              <ol start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Cancellation For Policies In Effect 90 Days Or Less</b>
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      If this policy has been in effect for g0 days or less, we
                      may cancel this policy by mailing or delivering to the
                      first Named Insured written notice of cancellation,
                      accompanied by the specific reasons for cancellation, at
                      least:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(1) </b>(1) 10 days before the effective date of
                          cancellation if we cancel for nonpayment of premium:
                          or
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(2) </b>(2) 20 days before the effective date of
                          cancellation if we cancel for any other reason, except
                          we may cancel immediately if there has been:
                          <ul style="list-style-type: none">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                              <b>(a) </b>(a) A material misstatement or
                              misrepresentation; or
                            </span>
                            </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                              <b>(b) </b>(b) A failure to comply with
                              underwriting requirements established by the
                              insurer.
                            </span>
                            </li>
                          </ul>
                        </span>
                        </li>
                      </ul>
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      We may not cancel:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(1) </b>On the basis of property insurance claims
                          that are the result of an act of God, unless we can
                          demonstrate, by claims frequency or otherwise, that
                          you have failed to take action reasonably necessary as
                          requested by us to prevent recurrence of damage to the
                          insured property; or
                        </span>
                        </li>
                      </ul>
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>Solely on the basis of a single property insurance
                  claim which is the result of water damage, unless we can
                  demonstrate that you have failed to take action reasonably
                  requested by us to prevent a future similar occurrence of
                  damage to the insured property.
                </span>
                </li>
              </ul>
            </span>
            </li>
          </ul>
          <ol type="A" start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Paragraph <b>5.</b> of the <b>Cancellation</b> Common Policy
              Condition is replaced by the following:
              <ol start="5">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  If this policy is cancelled, we will send the first Named
                  Insured any premium refund due. If we cancel, the refund will
                  be pro rata. If the first Named Insured cancels, the refund
                  may be less than pro rata If the return premium is not
                  refunded with the notice of cancellation or when this policy
                  is returned to us, we will mail the refund within 15 working
                  days after the date cancellation takes effect, unless this is
                  an audit policy.<br />
                  If this is an audit policy, then, subject to your full
                  cooperation with us or our agent in securing the necessary
                  data for audit, we will return any premium refund due within
                  g0 days of the date cancellation takes effect. If our audit is
                  not completed within this time limitation, then we shall
                  accept your own audit, and any premium refund due shall be
                  mailed within 10 working days of receipt of your audit.<br />
                  The cancellation will be effective even if we have not made or
                  offered a refund.
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 6 -->
<div class="pdf-page app-aul-013-24-02">
  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          <ol type="A" start="3">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following is added to the <b>Cancellation</b>
              Common Policy Condition:
              <ol start="7">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b
                    >Cancellation For Policies In Effect For More Than 90
                    Days</b
                  >
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      If this policy has been in effect for more than 90 days,
                      we may cancel this policy only for one or more of the
                      following reasons:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(1) </b>Nonpayment of premium;</span>
                </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(2) </b>The policy was obtained by a material
                          misstatement;
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(3) </b>In the event of failure to comply, within
                          90 days after the effective date of coverage, with
                          underwriting requirements established by us before the
                          effective date of coverage;
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(4) </b>There has been a substantial change in the
                          risk covered by the policy;
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(5) </b>The cancellation is for all insureds under
                          such policies for a given class of insureds;
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(6) </b>On the basis of property insurance claims
                          that are the result of an act of God, if we can
                          demonstrate, by claims frequency or otherwise, that
                          you have failed to take action reasonably necessary as
                          requested by us to prevent recurrence of damage to the
                          insured property;
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(7) </b>On the basis of a single property insurance
                          claim which is the result of water damage, if we can
                          demonstrate that you have failed to take action
                          reasonably requested by us to prevent a future similar
                          occurrence of damage to the insured property; or
                        </span>
                        </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(8) </b>The cancellation of some or all of our
                          policies is necessary to protect the best interests of
                          the public or policyholders and such cancellation is
                          approved by the Florida Office of Insurance
                          Regulation.
                        </span>
                        </li>
                      </ul>
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      If we cancel this policy for any of these reasons, we will
                      mail or deliver to the first Named Insured written notice
                      of cancellation, accompanied by the specific reasons for
                      cancellation, at least:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(1) </b>10 days before the effective date of
                          cancellation if cancellation is for nonpayment of
                          premium;
                        </span>
                        </li>
                      </ul>
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>45 days before the effective date of cancellation
                  if:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(a) </b>
                      Cancellation is for one or more of the reasons stated in
                      Paragraphs <b>7.a.(2)</b> through <b>7.a.(7)</b> above,
                      and this policy does not cover a residential structure or
                      its contents; or
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) </b>Cancellation is based on the reason stated in
                      Paragraph <b>7.a.(8)</b> above;
                    </span>
                    </li>
                  </ul>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(3) </b>120 days before the effective date of cancellation
                  if:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(a) </b>Cancellation is for one or more of the reasons
                      stated in Paragraphs <b>7.a.(2)</b> through
                      <b>7.a.(7)</b> above; and
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) </b>This policy covers a residential structure or
                      its contents.
                    </span>
                    </li>
                  </ul>
                </span>
                </li>
              </ul>
              <ol type="a" start="3">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  If this policy has been in effect for more than 90 days and
                  covers a residential structure or its contents, we may not
                  cancel this policy based on credit information available in
                  public records.
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ul>
          <ol type="A" start="4">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following is added: <br />
              <b>Nonrenewal</b>
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  If we decide not to renew this policy, we will mail or deliver
                  to the first Named Insured written notice of nonrenewal,
                  accompanied by the specific reason for nonrenewal, at least:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      45 days prior to the expiration of the policy if this
                      policy does not cover a residential structure or its
                      contents, or if nonrenewal is for the reason stated in
                      Paragraph <b>D.5.;</b> or
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      120 days prior to the expiration of the policy if this
                      policy covers a residential structure or its contents.
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Any notice of nonrenewal will be mailed or delivered to the
                  first Named Insured at the last mailing address known to us.
                  If notice is mailed, proof of mailing will be sufficient proof
                  of notice.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  We may not refuse to renew this policy:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      On the basis of property insurance claims that are the
                      result of an act of God, unless we can demonstrate, by
                      claims frequency or otherwise, that you have failed to
                      take action reasonably necessary as requested by us to
                      prevent recurrence of damage to the insured property;
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 7 -->
<div class="pdf-page app-aul-013-24-02">
  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ol type="a" start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  On the basis of filing of claims for sinkhole loss. However,
                  we may refuse to renew this policy if:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(1) </b>The total of such property insurance claim
                      payments for this policy equals or exceeds the policy
                      limits in effect on the date of loss for property damage
                      to the covered building; or
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(2) </b>You have failed to repair the structure in
                      accordance with the engineering recommendations upon which
                      any loss payment or policy proceeds were based; or
                    </span>
                    </li>
                  </ul>
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Solely on the basis of a single property insurance claim which
                  is the result of water damage, unless we can demonstrate that
                  you have failed to take action reasonably requested by us to
                  prevent a future similar occurrence of damage to the insured
                  property.
                </span>
                </li>
              </ol>
            </span>
            </li>
            <ol start="4">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                Notwithstanding the provisions of Paragraph <b>D.3.,</b> we may
                refuse to renew this policy if this policy includes Sinkhole
                Loss coverage. If we nonrenew this policy for purposes of
                removing Sinkhole Loss coverage, pursuant to section 627.706,
                Florida Statutes, we will offer you a policy that includes
                catastrophic ground cover collapse coverage.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                Notwithstanding the provisions of Paragraph <b>D.3.,</b> we may
                refuse to renew this policy if nonrenewal of some or all of our
                policies is necessary to protect the best interests of the
                public or policyholders and such nonrenewal is approved by the
                Florida Office of Insurance Regulation.
              </span>
              </li>
            </ol>
          </ul>
          <ol type="A" start="5">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b
                >Limitations On Cancellation And Nonrenewal In The Event Of
                Hurricane Or Wind Loss - Residential Property
              </b>
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The following provisions apply to a policy covering a
                  residential structure or its contents, if such property has
                  sustained damage as a result of a hurricane or windstorm that
                  is the subject of a declaration of emergency by the Governor
                  and filing of an order by the Commissioner of Insurance
                  Regulation:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      Except as provided in Paragraph <b>E.1.b.,</b> we may not
                      cancel or nonrenew the policy until at least 90 days after
                      repairs to the residential structure or its contents have
                      been substantially completed so that it is restored to the
                      extent that it is insurable by another insurer writing
                      policies in Florida. If we elect to not renew the policy,
                      we will provide at least 100 days' notice that we intend
                      to nonrenew 90 days after the substantial completion of
                      repairs.
                    </span>
                    </li>
                  </ol>
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ol type="a" start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  We may cancel or nonrenew the policy prior to restoration of
                  the structure or its contents for any of the following
                  reasons:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(1) </b>Nonpayment of premium;</span>
                </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(2) </b>Material misstatement or fraud related to the
                      claim;
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(3) </b>We determine that you have unreasonably caused
                      a delay in the repair of the structure; or
                    </span>
                    </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(4) </b>We have paid the policy limits.</span>
                </li>
                  </ul>
                  If we cancel or nonrenew for nonpayment of premium, we will
                  give you 10 days' notice. If we cancel or nonrenew for a
                  reason listed in Paragraph <b>b.(2), b.(3)</b> or
                  <b>b.(4),</b> we will give you 45 days' notice.
                </span>
                </li>
              </ol>
            </span>
            </li>
          </ul>
          <ol start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              With respect to a policy covering a residential structure or its
              contents, any cancellation or nonrenewal that would otherwise take
              effect during the duration of a hurricane will not take effect
              until the end of the duration of such hurricane, unless a
              replacement policy has been obtained and is in effect for a claim
              occurring during the duration of the hurricane. ‘We may collect
              premium for the period of time for which the policy period is
              extended.
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              With respect to Paragraph <b>E.2.,</b> a hurricane is a storm
              system that has been declared to be a hurricane by the National
              Hurricane Center of the National Weather Service (hereafter
              referred to as NHC). The hurricane occurrence begins at the time a
              hurricane watch or hurricane warning is issued for any part of
              Florida by the NHC and ends 72 hours after the termination of the
              last hurricane watch or hurricane warning issued for any part of
              Florida by the NHC.
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 8 -->
<div class="pdf-page app-aul-013-24-02">
  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <div>
      <p class="font-medium">
        <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
      </p>
      <br />
      <p class="font-medium">
        The Company hereby designates the Chief Financial Officer of the Florida
        Office Of Financial Regulation and his or her successors, as its true
        and lawful attorney upon whom may be served and lawful process in any
        action, suit proceeding instituted by you or on your behalf or by any
        beneficiary under this policy against the Company arising out of this
        policy, provided that all lawful process received by said Chief
        Financial Offer or his or her successors, is sent by certified or
        registered mail to the Company at:
      </p>
      <br />
      <p class="font-medium">
        <b>Fortegra Specialty Insurance Company</b>
      </p>
      <p class="font-medium">
        <b
          >Attn: Trenton Bavaro c/o Corporate Creations Network Inc. 801 US
          Highway 1</b
        >
      </p>
      <p class="font-medium">
        <b>North Palm Beach, FL 33408</b>
      </p>
      <br />
      <p class="font-medium">
        Service of process in any such action will also be valid if served upon
        any person in the State Of Florida who, on behalf of the Company,
        solicits insurance within the State of Florida; makes, issues or
        delivers insurance policies within the State of Florida; or collects or
        receives any premiums or other consideration for Company.
      </p>
      <br />
      <p class="font-medium">
        Service of process shall be deemed to be proper and lawful when in
        compliance with Florida Statutes, Surplus Lines Law Section 626.907.
      </p>
    </div>
  </div>
</div>
